import { IApplicationState } from '../../types/redux';

export const getPublishedReviewId = (state: IApplicationState): number | null => {
  return state.newReview.meta.publishedReviewId;
};
